import { useNavigate } from "react-router-dom";

export default function PublicHeader({
  mobileNavOpen,
  setMobileNavOpen,
  showAuth = true
}) {
  const navigate = useNavigate();

  if (mobileNavOpen) return null;

  return (
    <>
      <header className="nav-burger-wrap">
        <button
          className="nav-burger"
          onClick={() => setMobileNavOpen(true)}
        >
          ☰
        </button>
      </header>
      
      {showAuth && (
      <nav className="page-auth">
        <button
          type="button"
          className="auth-link auth-link--primary"
          onClick={() => navigate("/new")}
        >
          sign up
        </button>

        <span className="auth-sep">
          ·
        </span>

        <button
          type="button"
          className="auth-link auth-link--quiet"
          onClick={() => navigate("/returning")}
        >
          log in
        </button>
      </nav>
      )}
    </>
  );
}